module.exports = __webpack_public_path__ + "media/images/Empfehlungsbund-6492a11f.png";